(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('.section-header');
    this.headerHeading = this.header.querySelector('.header__heading');
    this.headerIcons = this.header.querySelector('.header__icons');
    this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
    this.headerBounds = {};

    this.setHeaderHeight();

    this.isMobile = window.matchMedia('(max-width: 990px)');
    this.isMobile.addEventListener('change', this.setHeaderHeight.bind(this));

    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-sticky');
    }

    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => this.preventReveal = true;

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();
  }

  setHeaderHeight() {
    document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
  }

  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    observer.observe(this.header);
  }

onScroll() {
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

  if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

  // Mobile-specific behavior (screen width <= 990px)
  if (this.isMobile.matches) {
    if (scrollTop <= this.headerBounds.top) {
      // When at the top of the page, show the header and ensure it remains sticky
      this.headerHeading.classList.remove('hidden', 'invisible');
      this.headerIcons.classList.remove('hidden', 'invisible');
      this.headerHeading.style.display = 'flex';
      this.headerIcons.style.display = 'flex';
      this.header.classList.add('shopify-section-header-sticky');
    } else if (scrollTop < this.currentScrollTop) {
      // Scrolling up: show the logo and icons, and keep sticky behavior
      this.headerHeading.classList.remove('invisible');
      this.headerIcons.classList.remove('invisible');
      this.headerHeading.classList.remove('hidden');
      this.headerIcons.classList.remove('hidden');
      this.header.classList.add('shopify-section-header-sticky'); // Keep the header sticky when scrolling up
    } else {
      // Scrolling down: hide logo and icons, remove sticky behavior
      this.header.classList.remove('shopify-section-header-sticky');
      setTimeout(() => {
        this.headerHeading.classList.add('invisible');
        this.headerIcons.classList.add('invisible');
        this.headerHeading.style.display = 'none';
        this.headerIcons.style.display = 'none';
      }, 300); // Delay visibility change until the opacity transition ends
    }
  } else {
    // Desktop behavior remains unchanged
    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (this.preventHide) return;
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);
        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);
        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top) {
      this.header.classList.remove('scrolled-past-header');
      requestAnimationFrame(this.reset.bind(this));
    }
  }

  // Update the current scroll position
  this.currentScrollTop = scrollTop;
}


  hide() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    this.closeMenuDisclosure();
    this.closeSearchModal();
  }

  reveal() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');
  }

  reset() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  }

  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
    this.disclosures.forEach(disclosure => disclosure.close());
  }

  closeSearchModal() {
    this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    this.searchModal.close(false);
  }
}

customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ja-image-box-with-text"] && !Shopify.designMode) return;
  try {
    
  if (window.innerWidth < 1200) {
    function imageBoxItemClickHandler() {
      const parent = this.parentElement.parentElement;

      if (parent.classList.contains("active")) {
        parent.classList.remove("active");
      } else {
        parent.classList.add("active");
      }
    }
    
    const imageBoxItems = document.querySelectorAll(".ja-image-box-with-text-item__title");
    imageBoxItems.forEach((item) => {
      item.addEventListener("click", imageBoxItemClickHandler);
    });
  }

  } catch(e) { console.error(e); }
})();
})();
